export enum FONT_TYPES {
  CUSTOM = 'CUSTOM',
  GOOGLE = 'GOOGLE',
}

export type Font = Partial<CustomFont> & {
  font_type: FONT_TYPES;
  google_font_family: string;
  is_unverified_font_selected: boolean;
};

export interface CustomFont {
  custom_font_name: string;
  custom_font_weight_400: CustomFontWeight;
  custom_font_weight_400_ttf: CustomFontFile;
  custom_font_weight_400_woff: CustomFontFile;
  custom_font_weight_700: CustomFontWeight;
  custom_font_weight_700_ttf: CustomFontFile;
  custom_font_weight_700_woff: CustomFontFile;
}

interface CustomFontWeight {
  created_at: string;
  font_id: number;
  id: number;
  name: string;
  updated_at: string;
}

interface CustomFontFile {
  default_url: string;
  file_name: string;
  file_url: string;
  id: number;
  mime_type: string;
  name: string;
  size: number;
  virus_scan_status: string;
}
